'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    OpenableFilterChip: ()=>OpenableFilterChip_OpenableFilterChip
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../DrawerToPopover/index.cjs");
const external_NonOpenableFilterChip_cjs_namespaceObject = require("./NonOpenableFilterChip.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const OpenableFilterChip_OpenableFilterChip = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, isOpen, onOpenChange, defaultOpen, title = 'openable-filter-chip-title', ...props }, ref) {
    const [internalIsOpen, setInternalIsOpen] = (0, external_react_namespaceObject.useState)(defaultOpen ?? false);
    const isControlled = void 0 !== isOpen;
    const currentIsOpen = isControlled ? isOpen : internalIsOpen;
    const { label, helperText, className, id, name, disabled, onClick, selected, onSelectionChange, iconLeft, value, count, filterType, type, elevated, emphasis, showCheckIcon, customNode, ...drawerToPopoverProps } = props;
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (isControlled && void 0 !== isOpen) setInternalIsOpen(isOpen);
    }, [
        isControlled,
        isOpen
    ]);
    const handleOpenChange = (open)=>{
        if (!isControlled) setInternalIsOpen(open);
        onOpenChange?.(open);
    };
    const nonOpenableChipProps = {
        label,
        helperText,
        id,
        name,
        disabled,
        onClick,
        selected,
        onSelectionChange,
        iconLeft,
        value,
        count,
        filterType,
        type,
        elevated,
        emphasis,
        showCheckIcon,
        customNode
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.DrawerToPopover, {
        triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_NonOpenableFilterChip_cjs_namespaceObject.NonOpenableFilterChip, {
            ref: ref,
            ...nonOpenableChipProps,
            className: (0, external_utils_index_cjs_namespaceObject.cn)(className, 'openable-filter-chip')
        }),
        disableTriggerFocus: true,
        open: currentIsOpen,
        onOpenChange: handleOpenChange,
        defaultOpen: defaultOpen,
        title: title,
        ...(0, external_utils_index_cjs_namespaceObject.cleanProps)(drawerToPopoverProps, [
            'opens'
        ]),
        children: children
    });
});
exports.OpenableFilterChip = __webpack_exports__.OpenableFilterChip;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "OpenableFilterChip"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
